import React from "react"

export default function Input({
  TextArea,
  rows,
  type,
  label,
  name,
  placeholder,
  className,
  value,
  register,
}) {
  if (TextArea) {
    return (
      <div className={`grid gap-2 ${className}`}>
        <label className="text-xs uppercase tracking-[0.1em]" htmlFor={name}>
          {label}
        </label>
        <textarea
          rows={rows}
          id={name}
          {...register(name)}
          className=" w-full text-sm resize-none  bg-transparent border border-stone-300 px-3 py-2 outline-none focus:outline-none placeholder-stone-500"
        />
      </div>
    )
  }

  return (
    <div className={`grid gap-2 ${className}`}>
      <label className="text-xs uppercase tracking-[0.1em]" htmlFor={name}>
        {label}
      </label>
      <input
        type={type}
        id={name}
        value={value}
        placeholder={placeholder}
        {...register(name)}
        className=" w-full text-sm  bg-transparent border border-stone-300 px-3 py-2 outline-none focus:outline-none placeholder-stone-400"
      />
    </div>
  )
}
